import { SearchIcon } from '@components';

const randomId = 'adue7af3ah';

// spa動作させない通常formとする
const Form = ({ action, shadow }: { action: string; shadow?: boolean }) => (
  <form action={action}>
    <div className='text-gray-400 focus-within:text-gray-600 relative'>
      <input
        name='q'
        className={`placeholder-gray-400 text-gray-900 w-full appearance-none rounded-lg bg-white px-4 py-3 pr-12 focus:outline-none lg:py-1 ${
          shadow ? 'shadow-md' : ''
        }`}
        aria-label='search'
        placeholder='Search'
      />
      <div className='absolute bottom-0 right-3 top-0 flex items-center'>
        <button type='submit' className='w-5 cursor-pointer'>
          <SearchIcon className='text-darkgray' />
        </button>
      </div>
    </div>
  </form>
);

export const HeaderSearchForm = ({
  action = '/knowledge/search/',
  popup = false,
}) => {
  if (!popup) {
    return <Form action={action} />;
  }

  return (
    <>
      <label
        htmlFor={randomId}
        className='relative flex h-5 cursor-pointer items-center'
      >
        <input type='checkbox' hidden className='peer' id={randomId} />
        <SearchIcon className='w-5 transition-all duration-300 hover:opacity-80 peer-checked:w-0' />
        <div className='fixed bottom-0 left-0 right-0 top-0 z-10 hidden peer-checked:block' />
        <div className='absolute right-0 top-[2rem] z-20 h-0 w-[15rem] overflow-hidden opacity-0 transition-opacity duration-300 peer-checked:h-auto peer-checked:overflow-visible peer-checked:opacity-100'>
          <Form action={action} shadow />
        </div>
      </label>
    </>
  );
};

export default HeaderSearchForm;
